import { render, staticRenderFns } from "./CampaignSynced.vue?vue&type=template&id=581a4b2c&scoped=true&"
import script from "./CampaignSynced.vue?vue&type=script&lang=js&"
export * from "./CampaignSynced.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSynced.vue?vue&type=style&index=0&id=581a4b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a4b2c",
  null
  
)

export default component.exports